export const VALID_LAYOUT_VALUES = [
    'fill',
    'fixed',
    'intrinsic',
    'responsive',
    'raw',
    undefined,
] as const;

export const VALID_LOADING_VALUES = ['lazy', 'eager', undefined] as const;

export const DEVICE_SIZES = [750, 828, 1080, 1200, 1920, 2048, 3840];

export const IMAGE_SIZES = [16, 32, 48, 64, 96, 128, 256, 384];

export const EMPTY_DATA_URL =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/**
 * Neutral grey shown behind clear-cut / multiplied product & professional imagery —
 * the fill the image sits on and blends into via `mix-blend-multiply`.
 * Single source of truth for this colour; keep in sync with the `--color-clearcut-fill`
 * CSS variable in `tailwind.css` (used by `bg-[var(--color-clearcut-fill)]` class sites).
 */
export const CLEARCUT_FILL_COLOR = '#FAFAFA';
